module.exports = __webpack_public_path__ + "img/animated-read.e05c0add.svg";